import type { CompleteOrderRequest } from '@/core/generated/api';
import type { CompleteOrderFormValues } from './model/completeOrderSchema';

/** Преобразует отчёт и загруженные фотографии в запрос завершения заказа */
export const completeOrderFormToRequest = (
    values: CompleteOrderFormValues,
    orderId: string,
    photoUrls: string[],
): CompleteOrderRequest => ({
    orderId,
    description: values.description.trim(),
    photoUrls: [...photoUrls],
});
